/* eslint-disable react-hooks/exhaustive-deps */
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { SignaturePadRef } from "../Add Risk Assessment/SignaturePadComponent";
import { Button } from "primereact/button";
import { Divider } from "primereact/divider";
import {
  convertDateToEpoch,
  convertDateToEpochUTC,
  convertEpochtoDate,
} from "../../../../helper/DateConverters";
import { dataURLToFile } from "../helper/helperFunctions";
import {
  fetchUsersList,
  getFormByFormID,
} from "../Job Sheet Gloucester/fetchData";
import { Toast } from "primereact/toast";
import { MultiSelect } from "primereact/multiselect";
import { fetchVehiclesList } from "./fetchData";
import { showError, showSuccess } from "../../../../util/ShowStatus";
import { getErrorMessage } from "../../../../helper/getResponseMessage";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "../../../../util/axiosconfig";
import { ProgressSpinner } from "primereact/progressspinner";
import PhotoUpload from "../Job Sheet Belfast/photoUpload";

// Helper function to convert URL to File object
const convertUrlToFile = async (url: any, filename: any) => {
  try {
    const response = await fetch(url);
    const blob = await response.blob();
    return new File([blob], filename, { type: blob.type });
  } catch (error) {
    console.error("Error converting URL to file:", error);
    return null;
  }
};

const EditJobsheetGloucesterForm = () => {
  const toast = useRef<Toast>(null);

  const navigate = useNavigate();
  const ImageNotAvailable = process.env.REACT_APP_IMAGE_NOT_FOUND_URL || "";

  const [photosLoading, setPhotosLoading] = useState(false);
  const [isUploadInProgress, setIsUploadInProgress] = useState(false);
  const [images, setImages] = useState<Record<string, File>>({});
  // const [dateIssued, setDateIssued] = useState<any>(new Date(Date.now()));
  const [targetCompletionDate, setTargetCompletionDate] = useState<any>(null);
  const [starTime, setStarTime] = useState<any>(null);
  const [finishTime, setFinishTime] = useState<any>(null);
  const [returnVisitStartDateTime, setReturnVisitStartDateTime] =
    useState<any>(null);
  const [returnVisitFinishDateTime, setReturnVisitFinishDateTime] =
    useState<any>(null);
  const [staffMembersRefs, setStaffMembersRefs] = useState<
    React.RefObject<SignaturePadRef>[]
  >([]);
  const [vehicle, setVehicle] = useState<any>(null);
  const [formSubmitting, setFormSubmitting] = useState(false);
  const [usersList, setUsersList] = useState<any[]>([]);
  const [staffMembers, setStaffMembers] = useState<any[]>([]);
  const [fileValues, setFileValues] = useState<any[]>([]);
  const [vehiclesList, setVehiclesList] = useState<any[]>([]);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [existingSignatures, setExistingSignatures] = useState<any[]>([]);

  const [formValues, setFormValues] = useState<any>({
    // invoiceNo: null,
    amelioID: null,
    jobOrderNo: null,
    // invoiceValue: null,
    // dateIssued: convertDateToEpoch(new Date()),
    targetCompletionDate: null,
    clientName: null,
    clientAddress: null,
    siteAddress: null,
    amelioStaff: [],
    date: null,
    startTime: null,
    finishTime: null,
    travelTime: null,
    vehicleRegistration: null,
    vehicleType: null,
    jobDescription: null,
    worksCarriedOut: null,
    returnVisitStartDateTime: null,
    returnVisitFinishDateTime: null,
    remedialAction: null,
    signedDate: null,
  });
  const [fileData, setFileData] = useState<any>(null);
  const firstRef = useRef<any>(null);

  const [searchParams] = useSearchParams();
  const formID = searchParams.get("formID");
  const [formDataLoading, setFormDataLoading] = useState(true);

  const isDisabled = formSubmitting || isUploadInProgress || photosLoading;

  useEffect(() => {
    // fetchAmelioID(setFormValues, toast);

    // Set initial load to false after first render
    setIsInitialLoad(false);
  }, []);

  useEffect(() => {
    if (formValues?.vehicleRegistration) {
      fetchUsersList(setUsersList, toast, formValues, setStaffMembers, "edit");
      fetchVehiclesList(setVehiclesList, formValues, setVehicle, toast, "edit");
    }
  }, [formValues?.vehicleRegistration, formValues?.amelioStaff]);

  const handleInputChange = (field: string, value: any) => {
    setFormValues((prev: any) => ({
      ...prev,
      [field]: value,
    }));
    // Convert date values to UTC epoch for date/time fields
    // const dateFields = [
    //   "dateIssued",
    //   "date",
    //   "startTime",
    //   "finishTime",
    //   "returnVisitStartDateTime",
    //   "returnVisitFinishDateTime",
    // ];

    // let processedValue = value;
    // if (dateFields.includes(name) && value instanceof Date) {
    //   processedValue = convertDateToEpochUTC(value);
    //   if (name === "startTime")
    //     setStarTime(new Date(convertDateToEpoch(value) * 1000));
    //   if (name === "finishTime")
    //     setFinishTime(new Date(convertDateToEpoch(value) * 1000));
    //   if (name === "returnVisitStartDateTime")
    //     setReturnVisitStartDateTime(new Date(convertDateToEpoch(value) * 1000));
    //   if (name === "returnVisitFinishDateTime")
    //     setReturnVisitFinishDateTime(
    //       new Date(convertDateToEpoch(value) * 1000)
    //     );
    // }

    // setFormValues((prev: any) => ({
    //   ...prev,
    //   [name]: processedValue,
    // }));
  };

  const [timeStampLocationValues, setTimeStampLocationValues] = useState({
    locations: [],
    timeStamps: [],
  });

  const handleTimeChange = (name: string, value: any) => {
    // Convert time values to UTC epoch for time fields
    const timeFields = [
      "startTime",
      "finishTime",
      // "dateIssued",
      "targetCompletionDate",
      "returnVisitStartDateTime",
      "returnVisitFinishDateTime",
    ];

    let processedValue = value;
    if (timeFields.includes(name) && value instanceof Date) {
      processedValue = convertDateToEpoch(value);
    }

    setFormValues((prev: any) => ({
      ...prev,
      [name]: processedValue,
    }));
  };

  const getDisplayDate = (epochValue: any): Date | null => {
    if (!epochValue) return null;
    if (epochValue instanceof Date) return epochValue;
    if (typeof epochValue === "number") {
      return new Date(epochValue * 1000);
    }
    return null;
  };

  // Function to clear all signatures
  const clearAllSignatures = useCallback(() => {
    // Don't clear signatures on initial load
    if (isInitialLoad) return;

    // Clear client signature
    if (firstRef.current) {
      firstRef.current.clear();
    }

    // Clear all staff member signatures
    staffMembersRefs.forEach((ref) => {
      if (ref.current) {
        ref.current.clear();
      }
    });
  }, [staffMembersRefs, isInitialLoad]);

  // Update refs when additionalTeamMembers changes
  useEffect(() => {
    setStaffMembersRefs((prevRefs) => {
      // Keep existing refs
      const newRefs = [...prevRefs];
      // Add new refs if needed
      while (newRefs.length < staffMembers.length) {
        newRefs.push(React.createRef<any>());
      }
      // Remove extra refs if needed
      while (newRefs.length > staffMembers.length) {
        newRefs.pop();
      }
      return newRefs;
    });
  }, [staffMembers.length]);

  // Clear signatures when form values change
  useEffect(() => {
    clearAllSignatures();
  }, [
    // formValues?.invoiceNo,
    formValues?.amelioID,
    formValues?.jobOrderNo,
    // formValues?.invoiceValue,
    // formValues?.dateIssued,
    formValues?.targetCompletionDate,
    formValues?.clientName,
    formValues?.clientAddress,
    formValues?.siteAddress,
    formValues?.amelioStaff,
    formValues?.date,
    formValues?.startTime,
    formValues?.finishTime,
    formValues?.travelTime,
    formValues?.vehicleRegistration,
    formValues?.vehicleType,
    formValues?.jobDescription,
    formValues?.worksCarriedOut,
    formValues?.returnVisitStartDateTime,
    formValues?.returnVisitFinishDateTime,
    formValues?.remedialAction,
    clearAllSignatures,
  ]);

  // Clear signatures when photos change
  useEffect(() => {
    clearAllSignatures();
  }, [fileValues, clearAllSignatures]);

  // const handleClear = (signatureRef: any) => {
  //   if (signatureRef.current) {
  //     signatureRef.current.clear();
  //   }
  // };

  const getSignatureByType = (type: string) => {
    if (!fileData?.signature) return ImageNotAvailable;
    const signature = fileData.signature.find((sig: any) =>
      sig.originalname.includes(type)
    );
    return signature ? signature.file : ImageNotAvailable;
  };

  // Load existing form data for editing
  useEffect(() => {
    if (!formID) {
      showError("Form ID is required for editing", toast);
      navigate("/layout/health-and-safety/jobsheet-gloucester");
      return;
    }

    const loadFormData = async () => {
      try {
        setFormDataLoading(true);
        await getFormByFormID(
          async (data: any) => {
            // Make this function async
            if (data && data.formJson) {
              const formData = data;

              // Parse the form JSON data
              const parsedFormJson = formData.formJson;

              // Set form values from the loaded data
              setFormValues({
                amelioID: formData.amelioID || null,
                jobOrderNo: parsedFormJson.jobOrderNo || null,
                targetCompletionDate:
                  parsedFormJson.targetCompletionDate || null,
                clientName: parsedFormJson.clientName || null,
                clientAddress: parsedFormJson.clientAddress || null,
                siteAddress: parsedFormJson.siteAddress || null,
                amelioStaff: parsedFormJson.amelioStaff || [],
                date:
                  parsedFormJson.date ||
                  convertDateToEpochUTC(
                    new Date(new Date().setHours(0, 0, 0, 0))
                  ),
                startTime: parsedFormJson.startTime || null,
                finishTime: parsedFormJson.finishTime || null,
                travelTime: parsedFormJson.travelTime || null,
                vehicleRegistration: parsedFormJson.vehicleRegistration || null,
                vehicleType: parsedFormJson.vehicleType || null,
                jobDescription: parsedFormJson.jobDescription || null,
                worksCarriedOut: parsedFormJson.worksCarriedOut || null,
                returnVisitStartDateTime:
                  parsedFormJson.returnVisitStartDateTime || null,
                returnVisitFinishDateTime:
                  parsedFormJson.returnVisitFinishDateTime || null,
                remedialAction: parsedFormJson.remedialAction || null,
                signedDate: parsedFormJson.signedDate || null,
              });

              // Set state for file data
              setFileData(formData.fileJson || null);

              // Set state for date/time fields
              setTargetCompletionDate(
                parsedFormJson.targetCompletionDate
                  ? new Date(parsedFormJson.targetCompletionDate * 1000)
                  : null
              );
              setStarTime(
                parsedFormJson.startTime
                  ? new Date(parsedFormJson.startTime * 1000)
                  : null
              );
              setFinishTime(
                parsedFormJson.finishTime
                  ? new Date(parsedFormJson.finishTime * 1000)
                  : null
              );
              setReturnVisitStartDateTime(
                parsedFormJson.returnVisitStartDateTime
                  ? new Date(parsedFormJson.returnVisitStartDateTime * 1000)
                  : null
              );
              setReturnVisitFinishDateTime(
                parsedFormJson.returnVisitFinishDateTime
                  ? new Date(parsedFormJson.returnVisitFinishDateTime * 1000)
                  : null
              );

              // Set selected staff members
              setStaffMembers(parsedFormJson.amelioStaff || []);

              // Set vehicle if exists
              if (parsedFormJson.vehicleRegistration) {
                // Find the vehicle in the vehicles list when it's loaded
                const vehicleInfo = {
                  registration_no: parsedFormJson.vehicleRegistration,
                  type: parsedFormJson.vehicleType,
                  vehicleType: parsedFormJson.vehicleType,
                };
                setVehicle(vehicleInfo);
              }

              // Handle site images from fileJson
              // Handle site images from fileJson
              if (formData.fileJson && formData.fileJson.siteImages) {
                try {
                  setPhotosLoading(true);
                  const imagePromises = formData.fileJson.siteImages.map(
                    async (imageItem: any) => {
                      const filename = imageItem.originalname;
                      let photoKey = "";
                      let photoIndex = "";

                      // Determine photo key based on filename
                      if (filename.includes("before")) {
                        // Extract index from filename (e.g., "before-1.png" => "1")
                        const match = filename.match(/before-(\d+)\./);
                        photoIndex = match ? match[1] : "1";
                        photoKey = `before-${photoIndex}`;
                      } else if (filename.includes("after")) {
                        // Extract index from filename (e.g., "after-1.png" => "1")
                        const match = filename.match(/after-(\d+)\./);
                        photoIndex = match ? match[1] : "1";
                        photoKey = `after-${photoIndex}`;
                      }

                      // Convert URL to File object
                      const file = await convertUrlToFile(
                        imageItem.file,
                        filename
                      );

                      return {
                        photoKey,
                        file,
                        url: imageItem.file, // Keep original URL for reference
                      };
                    }
                  );

                  // Wait for all image conversions to complete
                  const convertedImages = await Promise.all(imagePromises);
                  const validImages = convertedImages.filter(
                    (img) => img.file !== null
                  );

                  setImages(
                    validImages.reduce(
                      (acc: Record<string, File>, img: any) => {
                        if (img.photoKey && img.file) {
                          acc[img.photoKey] = img.file;
                        }
                        return acc;
                      },
                      {}
                    )
                  );
                  setFileValues(validImages);
                  setPhotosLoading(false);
                } catch (error) {
                  console.error("Error processing site images:", error);
                  showError("Failed to process site images", toast);
                  setPhotosLoading(false);
                }
              }

              // Handle existing signatures from fileJson
              if (formData.fileJson && formData.fileJson.signature) {
                setExistingSignatures(formData.fileJson.signature);
              }
            }
          },
          setFormDataLoading,
          parseInt(formID),
          navigate,
          toast
        );
      } catch (error) {
        showError("Failed to load form data", toast);
        console.error("Error loading form data:", error);
        setPhotosLoading(false);
      } finally {
        setFormDataLoading(false);
      }
    };

    loadFormData();
  }, [formID, navigate]);

  const validateForm = () => {
    // Basic validation logic
    // if (!formValues?.invoiceNo || formValues?.invoiceNo.trim() === "") {
    //   showError("Invoice number is required", toast);
    //   return false;
    // }
    // if (!formValues?.amelioID) {
    //   showError("Amelio ID is required", toast);
    //   return false;
    // }
    // if (!formValues?.jobOrderNo || formValues?.jobOrderNo.trim() === "") {
    //   showError("Job Order No is required", toast);
    //   return false;
    // }
    // if (!formValues?.invoiceValue || formValues?.invoiceValue.trim() === "") {
    //   showError("Invoice Value is required", toast);
    //   return false;
    // }
    // if (!formValues?.dateIssued) {
    //   showError("Date Issued is required", toast);
    //   return false;
    // }
    // if (!formValues?.targetCompletionDate) {
    //   showError("Target Completion Date is required", toast);
    //   return false;
    // }
    if (!formValues?.clientName || formValues?.clientName.trim() === "") {
      showError("Client Name is required", toast);
      return false;
    }
    // if (!formValues?.clientAddress || formValues?.clientAddress.trim() === "") {
    //   showError("Client Address is required", toast);
    //   return false;
    // }
    if (!formValues?.siteAddress || formValues?.siteAddress.trim() === "") {
      showError("Site Address is required", toast);
      return false;
    }
    if (!formValues?.amelioStaff || formValues?.amelioStaff.length === 0) {
      showError("At least one Amelio Staff member is required", toast);
      return false;
    }
    if (!formValues?.date) {
      showError("Date is required", toast);
      return false;
    }
    if (!formValues?.startTime) {
      showError("Start Time is required", toast);
      return false;
    }
    if (!formValues?.finishTime) {
      showError("Finish Time is required", toast);
      return false;
    }

    // Validate that start time is not greater than finish time
    if (formValues.startTime && formValues.finishTime) {
      const startTime = new Date(formValues.startTime).getTime();
      const finishTime = new Date(formValues.finishTime).getTime();

      if (startTime > finishTime) {
        showError("Finish Time must not be earlier than Start Time", toast);
        return false;
      }
    }

    // if (!formValues?.travelTime || formValues?.travelTime.trim() === "") {
    //   showError("Travel Time is required", toast);
    //   return false;
    // }
    // const beforePhoto = fileValues.find(
    //   (photo: any) => photo.photoKey === "before_photo"
    // );
    // if (!beforePhoto || !beforePhoto.file) {
    //   showError("Site Before Image is required", toast);
    //   return false;
    // }
    // const afterPhoto = fileValues.find(
    //   (photo: any) => photo.photoKey === "after_photo"
    // );
    // if (!afterPhoto || !afterPhoto.file) {
    //   showError("Site After Image is required", toast);
    //   return false;
    // }

    // Validate photos
    const beforePhotos = fileValues.filter((photo: any) =>
      photo.photoKey?.startsWith("before-")
    );
    if (!beforePhotos.length) {
      showError("At least one Site Before Image is required", toast);
      return false;
    }

    const afterPhotos = fileValues.filter((photo: any) =>
      photo.photoKey?.startsWith("after-")
    );
    if (!afterPhotos.length) {
      showError("At least one Site After Image is required", toast);
      return false;
    }
    // if (!formValues?.vehicleRegistration) {
    //   showError("Vehicle Registration is required", toast);
    //   return false;
    // }
    // if (!formValues?.vehicleType) {
    //   showError("Vehicle Type is required", toast);
    //   return false;
    // }
    // if (
    //   !formValues?.jobDescription ||
    //   formValues?.jobDescription.trim() === ""
    // ) {
    //   showError("Job Description is required", toast);
    //   return false;
    // }
    if (
      !formValues?.worksCarriedOut ||
      formValues?.worksCarriedOut.trim() === ""
    ) {
      showError("Works Carried Out is required", toast);
      return false;
    }
    // if (!formValues?.returnVisitStartDateTime) {
    //   showError("Return Visit Start Date/Time is required", toast);
    //   return false;
    // }
    // if (!formValues?.returnVisitFinishDateTime) {
    //   showError("Return Visit Finish Date/Time is required", toast);
    //   return false;
    // }

    // // Validate that start time is not greater than finish time
    // if (
    //   formValues.returnVisitStartDateTime &&
    //   formValues.returnVisitFinishDateTime
    // ) {
    //   const startTime = new Date(formValues.returnVisitStartDateTime).getTime();
    //   const finishTime = new Date(
    //     formValues.returnVisitFinishDateTime
    //   ).getTime();

    //   if (startTime > finishTime) {
    //     showError(
    //       "Return Visit Finish Date/Time must not be earlier than Start Date/Time",
    //       toast
    //     );
    //     return false;
    //   }
    // }

    // if (
    //   !formValues?.remedialAction ||
    //   formValues?.remedialAction.trim() === ""
    // ) {
    //   showError("Remedial Action is required", toast);
    //   return false;
    // }
    // if (!firstRef.current || firstRef.current.isEmpty()) {
    //   showError("Client signature is required", toast);
    //   return false;
    // }
    // // Validate signatures for each staff member

    // if (staffMembers.length > 0) {
    //   const hasEmptyAdditionalSignatures = staffMembers.some(
    //     (member: any, index: number) => {
    //       const ref = staffMembersRefs[index];
    //       return ref.current?.isEmpty();
    //     }
    //   );
    //   if (hasEmptyAdditionalSignatures) {
    //     showError("Signatures for all Staff Members are required", toast);
    //     return false;
    //   }
    // }
    // Add your form validation logic here
    return true; // Return true if valid, false otherwise
  };

  const handleSave = async () => {
    // Logic to save the form data
    try {
      if (!validateForm()) {
        return;
      }
      setFormSubmitting(true);
      setIsUploadInProgress(true);
      // Prepare FormData
      const formData = new FormData();

      // 1. Process signatures
      const signatures: File[] = [];
      const photosArray: File[] = [];

      // Process teamMember1 signature
      if (firstRef.current && !firstRef.current.isEmpty()) {
        const signatureDataUrl = firstRef.current.toDataURL();
        const signatureFile = dataURLToFile(
          signatureDataUrl,
          `signed_client.png`
        );
        if (signatureFile) {
          signatures.push(signatureFile);
        }
      }

      // Process additional team members signatures
      staffMembers.forEach((member: any, index: number) => {
        const ref = staffMembersRefs[index];
        if (ref.current && !ref.current.isEmpty() && member.userID) {
          const signatureDataUrl = ref.current.toDataURL();
          const signatureFile = dataURLToFile(
            signatureDataUrl,
            `${member.userID}_sig.png`
          );
          if (signatureFile) {
            signatures.push(signatureFile);
          }
        }
      });

      // Add all signatures to FormData
      signatures.forEach((file, index) => {
        formData.append(`signature`, file);
      });

      fileValues.forEach((photoItem: any) => {
        if (photoItem?.photoKey && photoItem?.file) {
          const fileName = `${photoItem.photoKey}.png`;
          const dataURL = new Blob([photoItem.file], {
            type: "image/png",
          });
          const photoFile = new File([dataURL], fileName, {
            type: "image/png",
          });
          photosArray.push(photoFile);
        }
      });

      photosArray.forEach((file, index) => {
        formData.append("siteImages", file);
      });

      formData.append("gloucesterID", formID ?? "");

      formData.append("formJson", JSON.stringify(formValues));
      formData.append(
        "timeStampLocationJson",
        JSON.stringify(timeStampLocationValues)
      );
      formData.append("isWeb", "true");

      const response = await axios.post(
        "health-and-safety/edit-gloucester-job-sheet-form",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setFormSubmitting(false);
      showSuccess(response.data.Message, toast);
      setIsUploadInProgress(false);
      navigate("/layout/health-and-safety/jobsheet-gloucester");
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      setIsUploadInProgress(false);
      setFormSubmitting(false);
      showError(errorMessage, toast);
    }
  };

  if (formDataLoading) {
    return (
      <div className="tw-h-full tw-w-full tw-bg-transparent tw-flex tw-justify-center tw-items-center tw-absolute tw-top-0 tw-left-[50px] lg:tw-left-[120px] tw-z-50">
        <ProgressSpinner />
      </div>
    );
  }

  return (
    <React.Fragment>
      <Toast ref={toast} />
      <div className="tw-border-solid tw-border tw-border-[#E2E2e2] tw-rounded-lg tw-relative tw-bg-white ">
        <div className="tw-bg-[#F8FAFC] tw-p-4 tw-rounded-t-lg tw-border-b-[1px] tw-border-[#E2E8F0] tw-flex tw-justify-between tw-items-center">
          <h2 className="tw-text-lg sm:tw-text-xl xl:tw-text-2xl tw-font-semibold tw-text-[#101828]">
            Edit Gloucester Job Sheet
          </h2>
        </div>
        <div>
          <div className="tw-p-4">
            <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start tw-w-full tw-mb-3">
              <span className="tw-text-lg tw-font-medium ">
                Amelio Utilities Ltd.
              </span>
              <span className="tw-text-sm tw-text-[#667085]">
                5 Spinnaker Road, Gloucester
              </span>
              <span className="tw-text-sm tw-text-[#667085]">GL2 5FD.</span>
              <span className="tw-text-sm tw-text-[#667085]">
                Telephone: 01452 311991
              </span>
            </div>
            <Divider className="tw-my-6 tw-bg-gray-400 tw-h-[2px]" />

            {/* Display existing signatures if available */}
            {/* {existingSignatures.length > 0 && (
              <div className="tw-mb-6">
                <h3 className="tw-text-md tw-font-medium tw-mb-3 tw-text-[#101828]">
                  Existing Signatures (for reference)
                </h3>
                <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-4">
                  {existingSignatures.map((signature, index) => (
                    <div
                      key={index}
                      className="tw-border tw-border-gray-300 tw-rounded-lg tw-p-3"
                    >
                      <div className="tw-text-sm tw-font-medium tw-mb-2 tw-text-[#374151]">
                        {signature.originalname
                          .replace(".png", "")
                          .replace("_", " ")}
                      </div>
                      <img
                        src={signature.file}
                        alt={signature.originalname}
                        className="tw-w-full tw-h-24 tw-object-contain tw-border tw-border-gray-200 tw-rounded"
                      />
                    </div>
                  ))}
                </div>
                <Divider className="tw-my-6 tw-bg-gray-400 tw-h-[2px]" />
              </div>
            )} */}

            <div className="tw-grid tw-grid-cols-1 xl:tw-grid-cols-2 2xl:tw-grid-cols-3 tw-gap-3 tw-w-full">
              {/* <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start">
                <label className="leak-label">Invoice No</label>
                <InputText
                  type="text"
                  value={formValues?.invoiceNo ?? ""}
                  onChange={(e) =>
                    handleInputChange("invoiceNo", e.target.value)
                  }
                  className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-w-full"
                  // readOnly
                />
              </div> */}
              {/* <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start">
                <label className="leak-label">Amelio ID</label>
                <InputText
                  type="text"
                  value={formValues?.amelioID ?? "N/A"}
                  readOnly
                  className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-w-full tw-bg-gray-50"
                />
              </div>
              <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start">
                <label className="leak-label">Job/order No</label>
                <InputText
                  type="text"
                  value={formValues?.jobOrderNo ?? ""}
                  onChange={(e) =>
                    handleInputChange("jobOrderNo", e.target.value)
                  }
                  placeholder="Enter Job/Order No"
                  className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-w-full"
                />
              </div> */}
              {/* <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start">
                <label className="leak-label">Invoice Value</label>
                <InputText
                  type="text"
                  value={formValues?.invoiceValue ?? ""}
                  // value={formValues.invoiceValue}
                  onChange={(e) =>
                    handleInputChange("invoiceValue", e.target.value)
                  }
                  placeholder="Enter Invoice Value"
                  className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-w-full"
                />
              </div> */}
              {/* <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start">
                <label className

  return (
    <React.Fragment>
      <Toast ref={toast} />
      <div className="tw-border-solid tw-border tw-border-[#E2E2e2] tw-rounded-lg tw-relative tw-bg-white ">
        <div className="tw-bg-[#F8FAFC] tw-p-4 tw-rounded-t-lg tw-border-b-[1px] tw-border-[#E2E8F0] tw-flex tw-justify-between tw-items-center">
          <h2 className="tw-text-lg sm:tw-text-xl xl:tw-text-2xl tw-font-semibold tw-text-[#101828]">
            Gloucester Job Sheet
          </h2>
        </div>
        <div>
          <div className="tw-p-4">
            <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start tw-w-full tw-mb-3">
              <span className="tw-text-lg tw-font-medium ">
                Amelio Utilities Ltd.
              </span>
              <span className="tw-text-sm tw-text-[#667085]">
                Unit 41, WorkWest Business Park, Gloucester,
              </span>
              <span className="tw-text-sm tw-text-[#667085]">
                BT11 8BU, UK.
              </span>
              <span className="tw-text-sm tw-text-[#667085]">
                Telephone: 028 9062 8585
              </span>
            </div>
            <Divider className="tw-my-6 tw-bg-gray-400 tw-h-[2px]" />

            <div className="tw-grid tw-grid-cols-1 xl:tw-grid-cols-2 2xl:tw-grid-cols-3 tw-gap-3 tw-w-full">
              {/* <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start">
                <label className="leak-label">Invoice No</label>
                <InputText
                  type="text"
                  value={formValues?.invoiceNo ?? ""}
                  onChange={(e) =>
                    handleInputChange("invoiceNo", e.target.value)
                  }
                  className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-w-full"
                  // readOnly
                />
              </div> */}
              <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start">
                <label className="leak-label">Amelio ID</label>
                <InputText
                  type="text"
                  value={formValues?.amelioID ?? "N/A"}
                  readOnly
                  className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-w-full tw-bg-gray-50"
                />
              </div>
              <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start">
                <label className="leak-label">Job/order No</label>
                <InputText
                  type="text"
                  value={formValues?.jobOrderNo ?? ""}
                  onChange={(e) =>
                    handleInputChange("jobOrderNo", e.target.value)
                  }
                  placeholder="Enter Job/Order No"
                  disabled={isDisabled}
                  className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-w-full"
                />
              </div>
              {/* <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start">
                <label className="leak-label">Invoice Value</label>
                <InputText
                  type="text"
                  value={formValues?.invoiceValue ?? ""}
                  // value={formValues.invoiceValue}
                  onChange={(e) =>
                    handleInputChange("invoiceValue", e.target.value)
                  }
                  placeholder="Enter Invoice Value"
                  className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-w-full"
                />
              </div> */}
              {/* <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start">
                <label className="leak-label">Date Issued</label>
                <Calendar
                  value={getDisplayDate(dateIssued)}
                  onChange={(e) => {
                    setDateIssued(e.value);
                    handleTimeChange("dateIssued", e.value);
                  }}
                  placeholder="Select Date Issued"
                  showIcon
                  showTime
                  dateFormat="dd-mm-yy"
                  hourFormat="24"
                  className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-w-full"
                />
              </div> */}
              {/* <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start tw-col-span">
                <label className="leak-label">Target Completion date</label>
                <Calendar
                  value={getDisplayDate(targetCompletionDate)}
                  // onChange={(e) =>
                  //   handleInputChange("targetCompletionDate", e.target.value)
                  // }
                  onChange={(e) => {
                    setTargetCompletionDate(e.value);
                    handleTimeChange("targetCompletionDate", e.value);
                  }}
                  disabled={isDisabled}
                  placeholder="Select Target Completion Date"
                  showIcon
                  dateFormat="dd-mm-yy"
                  className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-w-full"
                />
              </div> */}
            </div>
            <Divider className="tw-my-6 tw-bg-gray-400 tw-h-[2px] tw-mt-[42px]">
              <span className="tw-font-semibold">Client Details </span>
            </Divider>
            <div className="tw-grid tw-grid-cols-1 xl:tw-grid-cols-2 tw-mt-3 tw-gap-3 tw-w-full">
              <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start tw-col-span tw-mt-3">
                <label className="leak-label">
                  Client Name <span className="tw-text-red-500">*</span>
                </label>
                <InputText
                  type="text"
                  value={formValues.clientName ?? ""}
                  onChange={(e) =>
                    handleInputChange("clientName", e.target.value)
                  }
                  disabled={isDisabled}
                  placeholder="Enter Client Name"
                  className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-[51px] tw-w-full"
                />
              </div>
              <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start tw-col-span tw-mt-3">
                <label className="leak-label">Client Address</label>
                <InputTextarea
                  rows={1}
                  value={formValues.clientAddress ?? ""}
                  onChange={(e) =>
                    handleInputChange("clientAddress", e.target.value)
                  }
                  disabled={isDisabled}
                  placeholder="Enter Client Address"
                  className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-w-full"
                />
              </div>
            </div>
            <Divider className="tw-my-6 tw-bg-gray-400 tw-h-[2px] tw-mb-[42px] tw-mt-[42px]">
              <span className="tw-font-semibold">Site Details </span>
            </Divider>
            <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start tw-col-span tw-mt-3">
              <label className="leak-label">
                Site Address <span className="tw-text-red-500">*</span>
              </label>
              <InputTextarea
                rows={4}
                value={formValues.siteAddress ?? ""}
                onChange={(e) =>
                  handleInputChange("siteAddress", e.target.value)
                }
                disabled={isDisabled}
                placeholder="Enter Site Address"
                className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-w-full"
              />
            </div>
            <div className="tw-grid tw-grid-cols-1 xl:tw-grid-cols-3 tw-mt-3 tw-gap-3 tw-w-full">
              <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start">
                <label className="leak-label" htmlFor="teamMember1">
                  Amelio Staff <span className="tw-text-red-500">*</span>
                </label>
                {/* <MultiSelect
                  value={staffMembers ?? []}
                  onChange={(e) => {
                    setFormValues((prev: any) => ({
                      ...prev,
                      amelioStaff: e.value.map((member: any) => ({
                        userID: member.userID,
                        displayName: member.displayName,
                      })),
                    }));
                    setStaffMembers(e.value);
                  }}
                  disabled={isDisabled}
                  maxSelectedLabels={2}
                  options={usersList}
                  optionLabel="displayName"
                  placeholder="Select Staff"
                  filter
                  className="custome-dropdown !tw-w-full tw-h-11"
                /> */}

                {/* <InputText
                  type="text"
                  value={
                    formValues.amelioStaff
                      ?.map((member: any) => member.displayName)
                      .join(", ") ?? ""
                  }
                  // onChange={(e) =>
                  //   handleInputChange("clientName", e.target.value)
                  // }
                  readOnly
                  placeholder="Select Amelio Staff"
                  className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-[51px] tw-w-full"
                  /> */}

                <div className="tw-p-3 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-min-h-[44px] tw-w-full ">
                  <span className="tw-text-sm tw-text-[#667085] tw-flex tw-items-start tw-justify-start ">
                    {formValues.amelioStaff
                      ?.map((member: any) => member.displayName)
                      .join(", ") ?? ""}
                  </span>
                </div>
              </div>
              <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start">
                <label className="leak-label">
                  Date <span className="tw-text-red-500">*</span>
                </label>
                <Calendar
                  value={getDisplayDate(formValues.date)}
                  onChange={(e) => {
                    // Set date to UTC 12:00 AM
                    let selectedDate = e.value;
                    if (selectedDate instanceof Date) {
                      const utcDate = new Date(
                        Date.UTC(
                          selectedDate.getFullYear(),
                          selectedDate.getMonth(),
                          selectedDate.getDate(),
                          0,
                          0,
                          0,
                          0
                        )
                      );
                      handleInputChange("date", convertDateToEpoch(utcDate));
                    } else {
                      handleInputChange("date", null);
                    }
                  }}
                  disabled={isDisabled}
                  placeholder="Select Date"
                  showIcon
                  dateFormat="dd-mm-yy"
                  className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-w-full"
                />
              </div>
              <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start">
                <label className="leak-label">
                  Start Time <span className="tw-text-red-500">*</span>
                </label>
                <Calendar
                  value={getDisplayDate(starTime)}
                  onChange={(e) => {
                    setStarTime(e.value);
                    handleTimeChange("startTime", e.value);
                  }}
                  disabled={isDisabled}
                  placeholder="Select Start Time"
                  timeOnly
                  className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-w-full"
                />
              </div>
              {/* <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start">
                <label className="leak-label">
                  Finish Time <span className="tw-text-red-500">*</span>
                </label>
                <Calendar
                  value={getDisplayDate(finishTime)}
                  onChange={(e) => {
                    setFinishTime(e.value);
                    handleTimeChange("finishTime", e.value);
                  }}
                  disabled={isDisabled}
                  placeholder="Select Finish Time"
                  timeOnly
                  className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-w-full"
                />
              </div> */}
              <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start">
                <label className="leak-label">Travel Time</label>
                <InputText
                  type="text"
                  value={formValues?.travelTime ?? ""}
                  onChange={(e) =>
                    handleInputChange("travelTime", e.target.value)
                  }
                  disabled={isDisabled}
                  placeholder="Enter Travel Time"
                  className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-w-full"
                />
              </div>
            </div>
            <div className="tw-grid tw-grid-cols-1 xl:tw-grid-cols-2 tw-mt-3 tw-gap-3 tw-w-full">
              <PhotoUpload
                label={
                  <span>
                    Site Before Images (Max 10){" "}
                    <span className="tw-text-red-500">*</span>
                  </span>
                }
                name="before"
                images={images}
                isUploadInProgress={isUploadInProgress}
                setIsUploadInProgress={setIsUploadInProgress}
                setImages={setImages}
                fileValues={fileValues}
                setFileValues={setFileValues}
                timeStampLocationValues={timeStampLocationValues}
                setTimeStampLocationValues={setTimeStampLocationValues}
                classname="tw-w-full"
                maxImages={10}
                photosLoading={photosLoading}
                setPhotosLoading={setPhotosLoading}
              />
              <PhotoUpload
                label={
                  <span>
                    Site After Images (Max 10){" "}
                    <span className="tw-text-red-500">*</span>
                  </span>
                }
                name="after"
                images={images}
                isUploadInProgress={isUploadInProgress}
                setIsUploadInProgress={setIsUploadInProgress}
                setImages={setImages}
                fileValues={fileValues}
                setFileValues={setFileValues}
                timeStampLocationValues={timeStampLocationValues}
                setTimeStampLocationValues={setTimeStampLocationValues}
                classname="tw-w-full"
                maxImages={10}
                photosLoading={photosLoading}
                setPhotosLoading={setPhotosLoading}
              />
            </div>
            <Divider className="tw-my-6 tw-bg-gray-400 tw-h-[2px]">
              <span className="tw-font-semibold">Plant </span>
            </Divider>
            <div className="tw-grid tw-grid-cols-1 xl:tw-grid-cols-3 tw-mt-3 tw-gap-3 tw-w-full">
              <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start">
                <label className="leak-label">Vehicle Registration</label>
                <Dropdown
                  value={vehicle ?? ""}
                  onChange={(e) => {
                    setVehicle(e.value);
                    handleInputChange(
                      "vehicleRegistration",
                      e.value.registration_no
                    );
                    handleInputChange("vehicleType", e.value.vehicleType);
                  }}
                  disabled={isDisabled}
                  placeholder="Select Vehicle Registration"
                  filter
                  options={vehiclesList}
                  optionLabel="registration_no"
                  className="custome-dropdown !tw-w-full tw-h-11"
                />
              </div>
              <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start">
                <label className="leak-label">Vehicle Type</label>
                <InputText
                  type="text"
                  value={formValues?.vehicleType ?? ""}
                  // onChange={(e) => handleInputChange("vehicleType", e.value)}
                  readOnly
                  placeholder="Select vehicle registration for Vehicle Type"
                  className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-w-full tw-cursor-default tw-bg-gray-50"
                />
              </div>
            </div>
            {/* <Divider className="tw-my-6 tw-bg-gray-400 tw-h-[2px]" /> */}
            {/* <div className="tw-grid tw-grid-cols-1 xl:tw-grid-cols-2  tw-gap-3 tw-w-full tw-mt-3"> */}
            <Divider className="tw-my-6 tw-bg-gray-400 tw-h-[2px] tw-mb-[42px] tw-mt-[42px]">
              <span className="tw-font-semibold">Job Description </span>
            </Divider>
            <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start tw-col-span ">
              {/* <label className="leak-label">Job Description</label> */}
              <InputTextarea
                rows={4}
                value={formValues?.jobDescription ?? ""}
                onChange={(e) =>
                  handleInputChange("jobDescription", e.target.value)
                }
                disabled={isDisabled}
                placeholder="Enter Job Description"
                className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-w-full"
              />
            </div>
            <Divider className="tw-my-6 tw-bg-gray-400 tw-h-[2px] tw-mt-[42px] tw-mb-[42px]">
              <span className="tw-font-semibold">
                Works Carried out <span className="tw-text-red-500">*</span>
              </span>
            </Divider>
            <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start tw-col-span ">
              {/* <label className="leak-label">Works Carried out</label> */}
              <InputTextarea
                rows={4}
                value={formValues?.worksCarriedOut ?? ""}
                onChange={(e) =>
                  handleInputChange("worksCarriedOut", e.target.value)
                }
                disabled={isDisabled}
                placeholder="Enter Works Carried out"
                className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-w-full"
              />
            </div>
            {/* </div> */}
            <Divider className="tw-my-6 tw-bg-gray-400 tw-h-[2px] tw-mt-[42px] tw-mb-[42px]"></Divider>
            <div className="tw-grid tw-grid-cols-1 xl:tw-grid-cols-2 tw-mt-3 tw-gap-3 tw-w-full">
              {" "}
              <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start">
                <label className="leak-label">
                  Finish Time <span className="tw-text-red-500">*</span>
                </label>
                <Calendar
                  value={getDisplayDate(finishTime)}
                  onChange={(e) => {
                    setFinishTime(e.value);
                    handleTimeChange("finishTime", e.value);
                  }}
                  disabled={isDisabled}
                  placeholder="Select Finish Time"
                  timeOnly
                  className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-w-full"
                />
              </div>
              <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start">
                {/* <label className="leak-label">
                              Finish Time <span className="tw-text-red-500">*</span>
                            </label>
                            <Calendar
                              value={getDisplayDate(finishTime)}
                              onChange={(e) => {
                                setFinishTime(e.value);
                                handleTimeChange("finishTime", e.value);
                              }}
                              placeholder="Select Finish Time"
                              timeOnly
                              className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-w-full"
                            /> */}
              </div>
            </div>
            {/* <div className="tw-grid tw-grid-cols-1 xl:tw-grid-cols-2 tw-mt-3 tw-gap-3 tw-w-full">
              <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start">
                <label className="leak-label">
                  Return visit Start date and Time
                </label>
                <Calendar
                  value={getDisplayDate(returnVisitStartDateTime)}
                  onChange={(e) => {
                    setReturnVisitStartDateTime(e.value);
                    handleTimeChange("returnVisitStartDateTime", e.value);
                  }}
                  disabled={isDisabled}
                  placeholder="Select Return Visit Start Date/Time"
                  showTime
                  dateFormat="dd-mm-yy"
                  hourFormat="24"
                  className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-w-full"
                />
              </div>
              <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start">
                <label className="leak-label">
                  Return Visit Finish Date and Time
                </label>
                <Calendar
                  value={getDisplayDate(returnVisitFinishDateTime)}
                  onChange={(e) => {
                    setReturnVisitFinishDateTime(e.value);
                    handleTimeChange("returnVisitFinishDateTime", e.value);
                  }}
                  disabled={isDisabled}
                  placeholder="Select Return Visit Finish Date/Time"
                  showTime
                  hourFormat="24"
                  dateFormat="dd-mm-yy"
                  className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-w-full"
                />
              </div>
            </div>
            <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start tw-mt-3">
              <label className="leak-label">Remedial Action</label>
              <InputTextarea
                rows={4}
                value={formValues?.remedialAction ?? ""}
                onChange={(e) =>
                  handleInputChange("remedialAction", e.target.value)
                }
                disabled={isDisabled}
                placeholder="Enter Remedial Action"
                className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-w-full"
              />
            </div> */}
            <div className="tw-w-full tw-mb-8">
              <h3 className="tw-text-lg tw-font-semibold tw-text-gray-700 tw-mb-4  tw-px-4 tw-pb-2 tw-border-b tw-border-gray-200">
                Signatures
              </h3>
              <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 lg:tw-grid-cols-4 tw-gap-6 tw-px-4 tw-w-full">
                <div className="tw-flex tw-flex-col tw-w-full">
                  <span className="tw-text-sm tw-font-medium tw-text-gray-500 tw-mb-2">
                    Client Signature
                  </span>
                  <div className="tw-border tw-border-gray-200 tw-rounded tw-p-4 tw-bg-gray-50 tw-flex tw-flex-col tw-items-center tw-w-full">
                    <img
                      src={getSignatureByType("client")}
                      alt="client signature"
                      className="tw-h-24 tw-object-contain"
                    />
                    <div className="tw-mt-3 tw-text-center tw-flex tw-justify-between tw-items-center tw-w-full">
                      <p className="tw-font-medium tw-text-gray-800 tw-max-w-[50%] tw-break-words tw-whitespace-normal tw-text-left">
                        {formValues?.clientName || "N/A"}
                      </p>
                      <p className="tw-text-base tw-mt-[2px] tw-font-medium tw-text-gray-500">
                        {formValues?.signedDate
                          ? convertEpochtoDate(formValues?.signedDate)
                          : "N/A"}
                      </p>
                    </div>
                  </div>
                </div>

                {formValues?.amelioStaff?.length > 0 ? (
                  formValues.amelioStaff.map((staff: any, idx: number) => {
                    const staffId =
                      staff.id ||
                      staff.userID ||
                      staff._id ||
                      staff.staffID ||
                      "";
                    const signature =
                      fileData.signature.find(
                        (sig: any) =>
                          staffId && sig.originalname.includes(`${staffId}_sig`)
                      ) || {};
                    return (
                      <div
                        className="tw-flex tw-flex-col tw-w-full"
                        key={staffId || idx}
                      >
                        <span className="tw-text-sm tw-font-medium tw-text-gray-500 tw-mb-2">
                          Engineer Signature ({staff.displayName || "N/A"})
                        </span>
                        <div className="tw-border tw-border-gray-200 tw-rounded tw-p-4 tw-bg-gray-50 tw-flex tw-flex-col tw-items-center tw-w-full">
                          <img
                            src={signature.file || ImageNotAvailable}
                            alt="engineer signature"
                            className="tw-h-24 tw-object-contain"
                          />
                          <div className="tw-mt-3 tw-text-center tw-flex tw-justify-between tw-items-center tw-w-full">
                            <p className="tw-font-medium tw-text-gray-800 tw-max-w-[60%] tw-break-words tw-whitespace-normal tw-text-left">
                              {staff.displayName || "N/A"}
                            </p>
                            <p className="tw-text-base tw-mt-[2px] tw-font-medium tw-text-gray-500">
                              {formValues?.signedDate
                                ? convertEpochtoDate(formValues?.signedDate)
                                : "N/A"}
                            </p>
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div className="tw-flex tw-flex-col tw-w-full">
                    <span className="tw-text-sm tw-font-medium tw-text-gray-500 tw-mb-2">
                      Engineer Signature
                    </span>
                    <div className="tw-border tw-border-gray-200 tw-rounded tw-p-4 tw-bg-gray-50 tw-flex tw-flex-col tw-items-center tw-w-full">
                      <img
                        src={ImageNotAvailable}
                        alt="engineer signature"
                        className="tw-h-24 tw-object-contain"
                      />
                      <div className="tw-mt-3 tw-text-center">
                        <p className="tw-font-medium tw-text-gray-800">N/A</p>
                        <p className="tw-text-sm tw-text-gray-500">N/A</p>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="tw-flex tw-justify-end tw-items-center tw-p-4  tw-gap-2 !tw-border-t-[#E2E8F0] tw-border-t-[1px]">
            <Button
              className="tw-flex tw-px-3 tw-py-2 tw-rounded focus:tw-shadow-none  !tw-border-[#C3E3F4] tw-text-[#344054] tw-font-medium"
              label="Cancel"
              color="white"
              onClick={() =>
                navigate("/layout/health-and-safety/jobsheet-gloucester")
              }
              disabled={formSubmitting}
            />
            <Button
              className="tw-flex tw-px-3 focus:tw-shadow-none tw-py-2 tw-rounded tw-bg-primary tw-border-primary tw-text-white tw-font-medium"
              label={`${formSubmitting ? "Updating..." : "Update"}`}
              loading={formSubmitting}
              disabled={isDisabled}
              onClick={handleSave}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default EditJobsheetGloucesterForm;
